/* PagingDeviceFeed.js */

"use strict";
const PagingFeed = require("../../../../../../lib/PagingFeed");
const _ = require("lodash");

class PagingDeviceFeed extends PagingFeed {
    _getFeed(options) {
        this._entityType = _.get(options, "entityType");
        return this._EntityDef.startQueryFeed(this._activeOrgId, this._entityType, this._filter, undefined, this._sort, this._initialPage);
    }
    _deviceAvilaFeedReestablish(filter) {
        if (filter) {
            this._filter = filter;
        }
        return this._feedReestablish();
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadIdsForSelection(tenantId, this._entityType, selection);
    }
}

module.exports = PagingDeviceFeed;
